import { getMyAccountId } from "./config";
export const hasAccountAccess = () => {
    const MYACCOUNT_ID = getMyAccountId();
    const userAccount = Number(localStorage.getItem("user_myaccount_id"));
    return userAccount === MYACCOUNT_ID;
};